export const navlinks = [
    {
      name: "Create",
      link: "/",
    },
    {
      name: "Battle&Crafting",
      link: "/b&c",
    },
    {
        name: "Market",
        link: "/market",
    }
  ];

  export const TRANSFORMERS_ADDRESS = "0xDc199Ed02C81486724f5C404Bec24C507E088dF1";
  export const TT_ADDRESS = "0xf397c357e32Ad554087c43d5fc6e5D4aa279a550";